import { render, staticRenderFns } from "./Packpages.vue?vue&type=template&id=4c742e2b&"
import script from "./Packpages.vue?vue&type=script&lang=js&"
export * from "./Packpages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports